//export const BASE_URL_API = `http://localhost/API`;
export const BASE_URL_API =`https://axm1332.uta.cloud/API/`;
